module.exports = __webpack_public_path__ + "static/media/main idea.373e0219.mp3";